module.exports = __webpack_public_path__ + "img/img98.b32a3e8f.png";